<template>
  <div class="order-div">
    <Form :rules="ruleFrom" :label-width="120" class="order-details">
      <Divider orientation="left">{{ $t("orderInfo") }}</Divider>
      <div class="from-div">
        <Row>
          <Col span="8">
            <FormItem :label="$t('order_userRef')" prop="shipperRef">
              <Input disabled v-model="orderDetails.client_refer_code"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('order_number')" prop="shipperRef">
              <Input disabled v-model="orderDetails.airway_number"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('orderservice')" prop="shipperRef">
              <Input disabled v-model="orderDetails.cod_type"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('order_price')" prop="shipperRef">
              <Input disabled v-model="orderDetails.cod_amount"></Input>
            </FormItem>
          </Col>

          <Col span="8">
            <FormItem :label="$t('packageType')" prop="shipperRef">
              <Input disabled v-model="orderDetails.product"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('order_pcs')" prop="shipperRef">
              <Input v-model="orderDetails.quantity" disabled></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('claim_weight')" prop="shipperRef">
              <Input :value="orderDetails.claim_weight" disabled></Input>
            </FormItem>
          </Col>
          <template
            v-if="pageText != 'orderConfirm' && pageText != 'orderWait'"
          >
            <Col span="8">
              <FormItem :label="$t('check_weight')" prop="shipperRef">
                <Input :value="orderDetails.check_weight" disabled></Input>
              </FormItem>
            </Col>
          </template>
          <template v-if="pageText == 'all'">
            <Col span="8">
              <FormItem :label="$t('显示发件人')" prop="display_shipper">
                <Input :value="orderDetails.display_shipper" disabled></Input>
              </FormItem>
            </Col>
          </template>
          <!-- <Col span="8">
            <FormItem :label="$t('contraband')" prop="shipperRef">
              <Input
                v-model="orderDetails.contraband_description"
                disabled
              ></Input>
            </FormItem>
          </Col> -->
          <Col span="8">
            <FormItem label="交货条款" prop="ddx">
              <Input
                disabled
                v-model="orderDetails.ddx"
                :rows="2"
              ></Input>
            </FormItem>
          </Col>
          <Col span="16">
            <FormItem :label="$t('order_desc')" prop="shipperRef">
              <Input
                type="textarea"
                disabled
                v-model="orderDetails.remarks"
                :rows="2"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </div>
      <Divider orientation="left">{{ $t("recipientInfo") }}</Divider>
      <div class="from-div">
        <Row :gutter="10">
          <Col span="8">
            <FormItem :label="$t('clientCompany')" prop="shipperRef">
              <Input v-model="orderDetails.consignee" disabled></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('order_recivre')" prop="shipperRef">
              <Input v-model="orderDetails.consignee_contact" disabled></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('from_country')" prop="shipperRef">
              <Input v-model="orderDetails.from_country_title" disabled></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('target_country')" prop="shipperRef">
              <Input v-model="orderDetails.to_country_title" disabled></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('city_name')" prop="shipperRef">
              <Input v-model="orderDetails.city_name" disabled></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('channel_code')" prop="shipperRef">
              <Input v-model="orderDetails.transport_mode" disabled></Input>
            </FormItem>
          </Col>

          <Col span="8">
            <FormItem :label="$t('order_phone')" prop="shipperRef">
              <Input v-model="orderDetails.consignee_cellular" disabled></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('order_phone1')" prop="shipperRef">
              <Input
                v-model="orderDetails.consignee_telephone"
                disabled
              ></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('agentName')" prop="shipperRef">
              <Input v-model="orderDetails.agent_name" disabled></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('Area')" prop="consigneeInfo.area">
              <Input
                type="textarea"
                disabled
                v-model="orderDetails.area"
                :rows="1"
              ></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="短地址">
              <Input
                type="textarea"
                disabled
                v-model="orderDetails.short_address_type + ' / ' + orderDetails.short_address"
                :rows="1"
              ></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('order_address')" prop="shipperRef">
              <Input
                type="textarea"
                disabled
                v-model="orderDetails.consignee_address"
                :rows="2"
              ></Input>
            </FormItem>
          </Col>
          <template
            v-if="
              orderDetails.old_city_name || orderDetails.old_consignee_address
            "
          >
            <Col span="8">
              <FormItem :label="$t('oldCity')" prop="shipperRef">
                <Input v-model="orderDetails.old_city_name" disabled></Input>
              </FormItem>
            </Col>
            <Col span="16">
              <FormItem :label="$t('oldConsigneeAddress')" prop="shipperRef">
                <Input
                  type="textarea"
                  disabled
                  v-model="orderDetails.old_consignee_address"
                  :rows="2"
                ></Input>
              </FormItem>
            </Col>
          </template>
        </Row>
      </div>
      <Divider orientation="left">{{ $t("skuInfo") }}</Divider>
      <div class="from-div">
        <Table border :columns="tableTitle" :data="orderDetails.goods"></Table>
      </div>
    </Form>
  </div>
</template>

<script>
export default {
  props: {
    orderDetails: {
      type: Object,
    },
    pageText: {
      type: String,
    },
  },
  mounted() {
    console.log(this.orderDetails)
  },
  data() {
    return {
      serviceList: ["NCND", "NOR"],
      packageTypeRadio: ["XPS", "DOX"],
      ruleFrom: {
        shipperRef: [
          {
            required: true,
            message: "cannot be empty",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("invoiceName"),
        key: "title",
        tooltip: true,
        align: "center",
      });
      columns.push({
        title: this.$t("invoicePCS"),
        key: "quantity",
        tooltip: true,
        align: "center",
      });
      columns.push({
        title: this.$t("invoiceWeight"),
        key: "weight",
        tooltip: true,
        align: "center",
      });
      columns.push({
        title: this.$t("invoiceInsValue"),
        key: "values",
        align: "center",
        tooltip: true,
      });
      columns.push({
        title: this.$t("SKUBarcode"),
        key: "description",
        tooltip: true,
        align: "center",
      });
      columns.push({
        title: this.$t("invoiceHSCod"),
        key: "hs_code",
        tooltip: true,
        align: "center",
      });
      return columns;
    },
  },
};
</script>

<style lang="less">
.from-div {
  border: none;
  border-bottom: 1px solid #e8eaec;
  padding: 30px 10px 10px;
  margin-top: -28px;
}
.from-div:last-child {
  border: none;
}
.order-div {
  height: 700px;
  overflow: auto;
  border: 1px solid #e8eaec;
  border-radius: 6px;
}
</style>
